// extracted by mini-css-extract-plugin
export default {"RMSPagination":"RMSPagination_RMSPagination__oMpx9","Active":"RMSPagination_Active__2EGfI"};